import { Component, EventEmitter, Input, OnInit, AfterViewInit, Output, ViewChild, ElementRef, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '@app/reducers';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { StripeElements } from '@stripe/stripe-js';
declare const Stripe: any;

@Component({
  selector: 'app-smash-stripe',
  templateUrl: './smash-stripe.component.html',
  styleUrls: ['./smash-stripe.component.scss']
})
export class SmashStripeComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('cardNumber') cardNumber: ElementRef;
  @ViewChild('cardExpiry') cardExpiry: ElementRef;
  @ViewChild('cardCvc') cardCvc: ElementRef;
  @Output() stripeDataUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() error: any;

  _cardNumber: any;
  _cardExpiry: any;
  _cardCvc: any;
  cardHandler = this.onChange.bind(this);
  stripe: typeof Stripe;
  elements: StripeElements;

  cn = false;
  ce = false;
  cc = false;

  cnComplete = false;
  ceComplete = false;
  ccComplete = false;

  stripeError = false;


  constructor(
    private store$: Store<fromRoot.State>,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.stripe = new Stripe(environment.stripeKey);
      this.elements = this.stripe.elements({ hideIcon: false, showIcon: true });
    }
    // listen to store resetPayment
    this.store$.select(fromRoot.getResetPayment)
      .subscribe((resetPayment) => {
        if (resetPayment) {
          this.regenerateToken();
        }
      });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.createStripeElements();
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.destroyStripeElements();
    }
  }

  createStripeElements() {
    this.cnComplete = false;
    this.ceComplete = false;
    this.ccComplete = false;
    const stripeStyle = {
      base: {
        iconColor: '#666EE8',
        '::placeholder': {
          color: '#CCCCCC',
        },
      },
    };
    this._cardNumber = this.elements.create('cardNumber', { style: stripeStyle, showIcon: true });
    this._cardExpiry = this.elements.create('cardExpiry', { style: stripeStyle });
    this._cardCvc = this.elements.create('cardCvc', { style: stripeStyle });
    this._cardNumber.mount(this.cardNumber.nativeElement);
    this._cardExpiry.mount(this.cardExpiry.nativeElement);
    this._cardCvc.mount(this.cardCvc.nativeElement);
    this._cardNumber.on('ready', () => (this.cn = true));
    this._cardExpiry.on('ready', () => (this.ce = true));
    this._cardCvc.on('ready', () => (this.cc = true));

    this._cardNumber.addEventListener('change', this.cardHandler);
    this._cardExpiry.addEventListener('change', this.cardHandler);
    this._cardCvc.addEventListener('change', this.cardHandler);
  }

  destroyStripeElements() {
    this._cardNumber.removeEventListener('change', this.cardHandler);
    this._cardNumber.destroy();
    this._cardExpiry.removeEventListener('change', this.cardHandler);
    this._cardExpiry.destroy();
    this._cardCvc.removeEventListener('change', this.cardHandler);
    this._cardCvc.destroy();
  }

  async onChange(s) {
    if (s.error) { return this.stripeDataUpdated.emit({ error: s.error }); }
    // if card number / expiry / cvc are complete then emit card token
    if (s.elementType === 'cardNumber') { this.cnComplete = s.complete; }
    if (s.elementType === 'cardExpiry') { this.ceComplete = s.complete; }
    if (s.elementType === 'cardCvc') { this.ccComplete = s.complete; }
    if (this.cnComplete && this.ceComplete && this.ccComplete) {
      const { token, error } = await this.stripe.createToken(this._cardNumber);
      this.stripeError = !!error;
      this.stripeDataUpdated.emit({ token, error });
    }
  }

  async regenerateToken() {
    if (this.cnComplete && this.ceComplete && this.ccComplete) {
      this.destroyStripeElements();
      this.createStripeElements();
    }
  }

  async onSubmit(form) {
  }
}
